import { useEffect, useState } from 'react';

export const DEFAULT_SUBREDDIT_ICON_URL =
  'https://res.cloudinary.com/di7ggr7vm/image/upload/v1732129317/subreddit_icon_no_bg_corrected_gyzo7j.png';

const SubredditIcon = ({ src, alt, className }) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [src]);

  const requestedSrc = src || DEFAULT_SUBREDDIT_ICON_URL;
  const renderedSrc = hasError
    ? DEFAULT_SUBREDDIT_ICON_URL
    : requestedSrc;

  const handleError = () => {
    if (renderedSrc !== DEFAULT_SUBREDDIT_ICON_URL) {
      setHasError(true);
    }
  };

  return (
    <img
      src={renderedSrc}
      alt={alt}
      className={className}
      onError={handleError}
    />
  );
};

export default SubredditIcon;
